// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--mGLHS","title":"_6c97079b1b--title--LuVj_","link":"_6c97079b1b--link--oPguz"};